import React, { useState, useEffect, Fragment } from "react";
import LaddaButton, { ZOOM_OUT, XS } from "react-ladda";
import { Table, Button } from "reactstrap";
import { LoadingMessage } from "../../Controls";
import ModalTax from "../../Modals/ModalTax";
import { useEntities } from "../../Wizzard";
import { Mode, WizzMode } from "../../types";
import { showToast } from "../../../../utils/Helper"
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
const Tax = ({
  mode,
  services,
  assetTaxes,
  assetId,
  wizzOnChange,
  wizzToggle,
  fields,
  role
}) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [modalTax, setModalTax] = useState({ open: false });
  const [deleting, setDeleting] = useEntities({});

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
  }, [mode]);

  const toggle = (props) => {
    setModalTax({ open: !modalTax.open, ...props });
  };

  // handle grid actions
  const handleAction = (action, taxId) => {
    if (action == Mode.Insert) {
      toggle({
        assetId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Update) {
      toggle({
        assetId,
        action,
        tax: assetTaxes.find((t) => t.TAXId == taxId),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Delete) {
      wizzToggle("confirm", {
        title: "Delete asset tax",
        message: "Are you sure you want to delete asset tax?",
        onConfirm: () => handleDelete(taxId),
      });
    }
  };

  // callback after modal confirm
  const handleSave = (action, tax) => {
    return services
      .updateTax({
        assetId,
        action,
        tax,
      })
      .then((res) => res.result)
      .then((result) => {
        if (result.Code == 200) {
          wizzOnChange({
            Taxes: [tax].concat(assetTaxes.filter((e) => e.TAXId != tax.TAXId)),
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }

        return result.Code;
      });
  };

  // callback after confirm delete
  const handleDelete = (id) => {
    
    //No puedo eliminar todos los tax si el Asset esta Ready to Book o Ready to Trade
    if (assetTaxes.length == 1 && (fields.AssetReadyToBook || fields.AssetReadyToTrade)){
      showToast('If Assets are Ready to Book or Ready to Trade, you cannot delete all their taxes.', true)
      return
    }
    
    setDeleting({ [id]: true });
    services
      .updateTax({
        assetId,
        action: Mode.Delete,
        tax: assetTaxes.find((e) => e.TAXId == id),
      })
      .then((res) => res.result)
      .then((result) => {
        setDeleting({ [id]: false });
        if (result.Code == 200) {
          assetTaxes.splice(
            assetTaxes.findIndex((e) => e.TAXId == id),
            1
          );
          wizzOnChange({
            Taxes: assetTaxes,
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }
      });
  };

  return (
    <div>
      {!readonly && (
        <Button
          color="primary"
          className="mb-3"
          onClick={() => handleAction(Mode.Insert)}
        >
          <i className="fa fa-plus mr-1" aria-hidden="true"></i>
          Add Tax
        </Button>
      )}
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Percentage</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {assetTaxes ? (
            <Fragment>
              {assetTaxes.map((item) => (
                <tr key={`sin-${item.TAXId}`}>
                  <td>{item.TAXName}</td>
                  <td>{item.TAXType}</td>
                  <td><FormattedNumber value={item.TAXPercentage} dataTypeDecimalName="percentage"/></td>
                  <td>
                    {!readonly && (
                      <Actions
                        id={item.TAXId}
                        action={handleAction}
                        deleting={!!deleting[item.TAXId]}
                        role={role}
                      />
                    )}
                  </td>
                </tr>
              ))}
              {assetTaxes.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>

      <ModalTax {...modalTax} toggle={toggle} services={services} />
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="3">
      {loading ? (
        <LoadingMessage text="Loading taxes" />
      ) : (
        <span className="text-center d-block h5 m-3">No taxes</span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, deleting, role }) => (
  <div className="d-flex justify-content-end">
    <Button
      color="primary"
      size="sm"
      className="mr-2"
      disabled={role && role !== "ops"}
      onClick={() => action(Mode.Update, id)}
    >
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action(Mode.Delete, id)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

export default Tax;
